import axios from "axios";
import React, { useEffect, useState } from "react";
import { FallingLines } from "react-loader-spinner";
import { base_url } from "../../utils/AxiosConfig";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaEye } from "react-icons/fa6";
import AddPayroll from "./AddPayroll";
import ViewPayroll from "./ViewPayroll";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";

const Payroll = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [data, setData] = useState();
  const [popUpData, setpopUpData] = useState();
  const [Open, setOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const [loader, setLoader] = useState(true);

  const [loadPayroll, setLoadPayroll] = useState(false);

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  useEffect(() => {
    if (data) {
      setLoader(false);
    }
  }, [data]);
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
        );
        if (response?.data) {
          setData(response.data);

          setReset(false);
        }
      } catch (error) {
        console.error("PersonalInfoListEerror:", error);
      }
    };

    getData();
  }, []);

  const setPayrollData = (data) => {
    setpopUpData("");
    if (data) {
      setpopUpData(data);
    }
  };

  useEffect(() => {
    if (popUpData) {
      console.log("setPayrollLoadEffect");
      setLoadPayroll(true);
    }
  }, [popUpData]);

  // console.log('popUpData',popUpData)

  const formatDateWithExpiry = (date) => {
    if (!date) return <span>-</span>;

    const parsed = new Date(date);
    if (isNaN(parsed)) return <span>-</span>;

    const isExpired = parsed < new Date();

    return (
      <span className={isExpired ? "text-red-600 font-medium" : ""}>
        {parsed.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    );
  };

  return (
    <div className="">
      <div className="container-fluid">
        <div className="flex justify-between items-end mb-4">
          {/* <div className="">
            <h6 className="text-2xl mb-4 font-bold text-gray-600 flex  justify-start items-center">
                Payroll Additions & Deductions
            </h6>  
          </div> */}

          <div className="flex justify-left items-center ">
            <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
            <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
              {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
              <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                PAYROLL ADDITIONS & DEDUCTIONS
              </span>
            </h6>
          </div>
          <div className="">
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
          </div>
        </div>

        <div
          // className={Open ? " scroll h-auto w-auto" : " scroll h-auto w-auto"}
          className="overflow-auto scrollbar-none mb-3 rounded-md"
          style={{ maxHeight: "800px" }}
        >
          {records ? (
            <>
              {/* <table className="table-auto w-full text-xs border-collapse border border-gray-300 shadow-sm rounded-md"> */}
              <table className="shadow-sm min-w-full bg-white rounded-sm border border-[gray-300] text-xs scrollbar-none">
                <thead>
                  <tr className="bg-[#2663EB] text-white">
                    <th className="px-1 py-1 font-normal">Sl No</th>
                    <th className="px-1 py-1 font-normal">Emp ID</th>
                    <th className="px-1 py-1 font-normal">Alternate ID</th>
                    <th className="px-1 py-1 font-normal">Status</th>
                    <th className="px-1 py-1 font-normal">Name</th>
                    <th className="px-1 py-1 font-normal">Job Title</th>
                    <th className="px-1 py-1 font-normal">Division</th>
                    <th className="px-1 py-1 font-normal">Grade</th>
                    <th className="px-1 py-1 font-normal">Gender</th>
                    <th className="px-1 py-1 font-normal">Nationality</th>

                    {Open && (
                      <>
                        <th className="px-1 py-1 font-normal ">Bank Account</th>
                        <th className="px-1 py-1 font-normal ">Bank Name</th>
                        <th className="px-1 py-1 font-normal ">Agent ID</th>
                        <th className="px-1 py-1 font-normal ">
                          Current Address
                        </th>
                        <th className="px-1 py-1 font-normal ">Home Address</th>
                        <th className="px-1 py-1 font-normal ">Home Airport</th>
                        <th className="px-1 py-1 font-normal ">Work Mobile</th>
                        <th className="px-1 py-1 font-normal ">Work Phone</th>
                        <th className="px-1 py-1 font-normal ">
                          Personal Phone
                        </th>
                        <th className="px-1 py-1 font-normal ">
                          Personal Email
                        </th>
                        <th className="px-1 py-1 font-normal ">Passport No</th>
                        <th className="px-1 py-1 font-normal ">
                          Passport Issue Date
                        </th>
                        <th className="px-1 py-1 font-normal ">
                          Passport Expiry Date
                        </th>
                        <th className="px-1 py-1 font-normal ">
                          Place of Issue
                        </th>
                        <th className="px-1 py-1 font-normal ">
                          Country of Issue
                        </th>
                        <th className="px-1 py-1 font-normal ">Emirates ID</th>
                        <th className="px-1 py-1 font-normal ">EID Expiry</th>
                        <th className="px-1 py-1 font-normal ">Visa No</th>
                        <th className="px-1 py-1 font-normal ">Visa Expiry</th>
                        <th className="px-1 py-1 font-normal ">Insurance No</th>
                        <th className="px-1 py-1 font-normal ">
                          Insurance Expiry
                        </th>
                        <th className="px-1 py-1 font-normal ">License No</th>
                        <th className="px-1 py-1 font-normal ">
                          License Expiry
                        </th>
                        <th className="px-1 py-1 font-normal ">Basic Pay</th>
                        <th className="px-1 py-1 font-normal ">OT Allowance</th>
                        <th className="px-1 py-1 font-normal ">
                          NOT Allowance
                        </th>
                        <th className="px-1 py-1 font-normal ">Normal Hrs</th>
                        <th className="px-1 py-1 font-normal ">Hourly Wage</th>
                        <th className="px-1 py-1 font-normal ">OT Rate</th>
                        <th className="px-1 py-1 font-normal ">
                          Special OT Rate
                        </th>
                        <th className="px-1 py-1 font-normal ">Active</th>
                        <th className="px-1 py-1 font-normal ">Memos</th>
                        <th className="px-1 py-1 font-normal ">Notes</th>
                        <th className="px-1 py-1 font-normal ">Salary Ac</th>
                        <th className="px-1 py-1 font-normal ">Advance Ac</th>
                      </>
                    )}

                    <th className="px-1 py-1 font-normal text-center">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {records?.map((d, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-3 py-2 border">{i + 1}</td>
                      <td className="px-3 py-2 border">{d.EmpId}</td>
                      <td className="px-3 py-2 border">{d.AlternateID}</td>
                      <td className="px-3 py-2 border">{d.Status}</td>
                      <td className="px-3 py-2 border">{d.Name}</td>
                      <td className="px-3 py-2 border">{d.JobTitle}</td>
                      <td className="px-3 py-2 border">{d.Division}</td>
                      <td className="px-3 py-2 border">{d.Grade}</td>
                      <td className="px-3 py-2 border">{d.Single}</td>
                      <td className="px-3 py-2 border">{d.Nationality}</td>

                      {Open && (
                        <>
                          <td className="px-3 py-2 border">
                            {d.BankAccountNo}
                          </td>
                          <td className="px-3 py-2 border">{d.BankName}</td>
                          <td className="px-3 py-2 border">{d.AgentID}</td>
                          <td className="px-3 py-2 border">
                            {d.CurrentAddress}
                          </td>
                          <td className="px-3 py-2 border">{d.HomeAddress}</td>
                          <td className="px-3 py-2 border">{d.HomeAirport}</td>
                          <td className="px-3 py-2 border">{d.WorkMobile}</td>
                          <td className="px-3 py-2 border">{d.WorkPhone}</td>
                          <td className="px-3 py-2 border">
                            {d.PersonalPhone}
                          </td>
                          <td className="px-3 py-2 border">
                            {d.PersonalEmail}
                          </td>
                          <td className="px-3 py-2 border">{d.PassportNo}</td>
                          <td className="px-3 py-2 border">
                            {formatDateWithExpiry(d.PassportIssueDate)}
                          </td>
                          <td className="px-3 py-2 border">
                            {formatDateWithExpiry(d.PassportExpiryDate)}
                          </td>
                          <td className="px-3 py-2 border">
                            {d.PassportPlaceofIssue}
                          </td>
                          <td className="px-3 py-2 border">
                            {d.PassportCountryofIssue}
                          </td>
                          <td className="px-3 py-2 border">{d.EmiratesId}</td>
                          <td className="px-3 py-2 border">
                            {formatDateWithExpiry(d.EmiratesIdExpiryDate)}
                          </td>
                          <td className="px-3 py-2 border">{d.VisaNo}</td>
                          <td className="px-3 py-2 border">
                            {formatDateWithExpiry(d.VisaExpiryDate)}
                          </td>
                          <td className="px-3 py-2 border">{d.InsuranceNo}</td>
                          <td className="px-3 py-2 border">
                            {formatDateWithExpiry(d.InsuranceExpiryDate)}
                          </td>
                          <td className="px-3 py-2 border">
                            {d.DrivingLicenceNo}
                          </td>
                          <td className="px-3 py-2 border">
                            {formatDateWithExpiry(d.DrivingLicenceExpiryDate)}
                          </td>
                          <td className="px-3 py-2 border">{d.BasicPay}</td>
                          <td className="px-3 py-2 border">
                            {d.Allowances_OT}
                          </td>
                          <td className="px-3 py-2 border">
                            {d.Allowances_NOT}
                          </td>
                          <td className="px-3 py-2 border">{d.NormalHrs}</td>
                          <td className="px-3 py-2 border">{d.HourlyWage}</td>
                          <td className="px-3 py-2 border">{d.OTrate}</td>
                          <td className="px-3 py-2 border">{d.SplOtRate}</td>
                          <td className="px-3 py-2 border">{d.Active}</td>
                          <td className="px-3 py-2 border">{d.Memos}</td>
                          <td className="px-3 py-2 border">{d.Notes}</td>
                          <td className="px-3 py-2 border">{d.SalaryAc}</td>
                          <td className="px-3 py-2 border">{d.AdvanceAc}</td>
                        </>
                      )}

                      <td className="px-3 py-2 border text-center space-x-2">
                        <button
                          className="bg-green-500 text-white px-2 py-1 rounded-md text-xs hover:bg-green-600"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                          onClick={() => setPayrollData(d)}
                        >
                          <IoIosAddCircleOutline className="inline-block mr-1" />
                          Add
                        </button>
                        <button
                          className="bg-blue-500 text-white px-2 py-1 rounded-md text-xs hover:bg-blue-600"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdropnew"
                          onClick={() => setPayrollData(d)}
                        >
                          <FaEye className="inline-block mr-1" />
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : null}
        </div>
        {records ? (
          <>
            <div className="pagination-div">
              <div className="text-end">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <li class="page-item">
                      {currentPage !== 1 ? (
                        <button class="page-link" href="#" onClick={prePage}>
                          Previous
                        </button>
                      ) : (
                        ""
                      )}
                    </li>
                    {numbers.map((n, i) => (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={i}
                      >
                        <button
                          className="page-link"
                          onClick={() => changeCPage(n)}
                          href="#"
                        >
                          {n}
                        </button>
                      </li>
                    ))}

                    <li class="page-item">
                      {currentPage !== numbers[numbers.length - 1] ? (
                        <button class="page-link" href="#" onClick={nextPage}>
                          Next
                        </button>
                      ) : null}
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </>
        ) : null}
        <AddPayroll popUpData={popUpData} setpopUpData={setpopUpData} />
        <ViewPayroll
          popUpData={popUpData}
          loadPayroll={loadPayroll}
          setLoadPayroll={setLoadPayroll}
          setpopUpData={setpopUpData}
        />

        <div className="table-nodata-img mtd">
          {loader ? (
            <>
              {" "}
              <div className="table-nodata-img">
                <div className="center">
                  <p className="text-center pt-5">
                    Please Wait Loading Data... &nbsp;
                    <FallingLines />
                  </p>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
};

export default Payroll;
